import { render, staticRenderFns } from "./DepartmentPickerField.vue?vue&type=template&id=bf9c664c&scoped=true"
import script from "./DepartmentPickerField.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentPickerField.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentPickerField.vue?vue&type=style&index=0&id=bf9c664c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9c664c",
  null
  
)

export default component.exports